export const SET_PRIVACY = 'privacy/new'
export const GET_PRIVACY = 'privacy/get'
export const SET_TERMS = 'terms/new'
export const GET_TERMS = 'terms/get'
